export enum CompanyFinancialsLocationFilterName {
  UsGrid = 'us',
  LocalGrid = 'local',
}
